import React, { Component } from 'react';
import AuthService from '../AuthService';
import constants from '../../config';
import { formatDate } from './shared/formatters';

var Auth = new AuthService();

var STATUS_BADGE = {
  active: { bg: '#10B981', label: 'Active' },
  suspended: { bg: '#f59e0b', label: 'Suspended' },
  banned: { bg: '#EF4444', label: 'Banned' },
  deleted: { bg: '#6B7280', label: 'Deleted' },
};

class AdminUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      pagination: { page: 1, limit: 25, total: 0, pages: 0 },
      loading: true,
      search: '',
      filterStatus: '',
      filterRole: '',
      sortBy: 'newest',
      dateFrom: '',
      dateTo: '',
      searchTimer: null,
    };
    this.fetchUsers = this.fetchUsers.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleExport = this.handleExport.bind(this);
  }

  componentDidMount() {
    this.fetchUsers(1);
  }

  fetchUsers(page) {
    var self = this;
    self.setState({ loading: true });
    var params = new URLSearchParams();
    params.append('page', page || 1);
    params.append('limit', 25);
    if (self.state.search) params.append('search', self.state.search);
    if (self.state.filterStatus) params.append('status', self.state.filterStatus);
    if (self.state.filterRole) params.append('role', self.state.filterRole);
    if (self.state.sortBy) params.append('sortBy', self.state.sortBy);
    if (self.state.dateFrom) params.append('dateFrom', self.state.dateFrom);
    if (self.state.dateTo) params.append('dateTo', self.state.dateTo);

    Auth.fetch(constants.DOMAIN + '/api/v1/admin/users?' + params.toString())
      .then(function(data) {
        self.setState({ users: data.users || [], pagination: data.pagination || {}, loading: false });
      })
      .catch(function(err) {
        console.log('Failed to fetch users:', err);
        self.setState({ loading: false });
      });
  }

  handleSearchChange(e) {
    var self = this;
    var value = e.target.value;
    if (self.state.searchTimer) clearTimeout(self.state.searchTimer);
    self.setState({
      search: value,
      searchTimer: setTimeout(function() { self.fetchUsers(1); }, 400),
    });
  }

  handleExport() {
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/users/export', { rawResponse: true })
      .then(function(res) {
        return res.blob ? res.blob() : res.text();
      })
      .then(function(data) {
        var blob = data instanceof Blob ? data : new Blob([data], { type: 'text/csv' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'users-' + new Date().toISOString().split('T')[0] + '.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      })
      .catch(function(err) {
        console.log('Failed to export users:', err);
      });
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var users = this.state.users;
    var pagination = this.state.pagination;
    var onOpenUserModal = this.props.onOpenUserModal;
    var hasFilters = this.state.search || this.state.filterStatus || this.state.filterRole || this.state.dateFrom || this.state.dateTo;

    return (
      <div>
        {/* Header */}
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-5">
          <div>
            <h2 className="tw-text-lg tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Users</h2>
            <p className="tw-text-sm tw-text-[#999] tw-m-0 tw-mt-0.5">{pagination.total || 0} total users</p>
          </div>
          <button
            className="tw-text-xs tw-px-4 tw-py-2.5 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
            style={{ backgroundColor: '#D4A843' }}
            onClick={this.handleExport}
          >
            <i className="fa fa-download tw-mr-1" />Export CSV
          </button>
        </div>

        {/* Filters */}
        <div className="tw-rounded-xl tw-p-4 tw-mb-4" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
          <div className="tw-flex tw-flex-wrap tw-gap-3 tw-items-center">
            <div className="tw-relative tw-flex-1" style={{ minWidth: 200 }}>
              <i className="fa fa-search tw-absolute tw-left-3 tw-text-[#999]" style={{ top: '50%', transform: 'translateY(-50%)', fontSize: 12 }} />
              <input
                type="text"
                className="tw-w-full tw-pl-8 tw-pr-3 tw-py-2.5 tw-text-sm tw-rounded-lg tw-border tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
                placeholder="Search by username or email..."
                value={this.state.search}
                onChange={this.handleSearchChange}
              />
            </div>
            <select
              className="tw-border tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
              value={this.state.filterStatus}
              onChange={function(e) { self.setState({ filterStatus: e.target.value }, function() { self.fetchUsers(1); }); }}
            >
              <option value="">All Status</option>
              <option value="active">Active</option>
              <option value="suspended">Suspended</option>
              <option value="banned">Banned</option>
              <option value="deleted">Deleted</option>
            </select>
            <select
              className="tw-border tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
              value={this.state.filterRole}
              onChange={function(e) { self.setState({ filterRole: e.target.value }, function() { self.fetchUsers(1); }); }}
            >
              <option value="">All Roles</option>
              <option value="user">User</option>
              <option value="admin">Admin</option>
            </select>
            <select
              className="tw-border tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
              value={this.state.sortBy}
              onChange={function(e) { self.setState({ sortBy: e.target.value }, function() { self.fetchUsers(1); }); }}
            >
              <option value="newest">Newest First</option>
              <option value="oldest">Oldest First</option>
              <option value="strikes">Most Strikes</option>
            </select>
            <input
              type="date"
              className="tw-border tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
              value={this.state.dateFrom}
              onChange={function(e) { self.setState({ dateFrom: e.target.value }, function() { self.fetchUsers(1); }); }}
              placeholder="From"
            />
            <input
              type="date"
              className="tw-border tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
              value={this.state.dateTo}
              onChange={function(e) { self.setState({ dateTo: e.target.value }, function() { self.fetchUsers(1); }); }}
              placeholder="To"
            />
            {hasFilters && (
              <button
                className="tw-text-xs tw-px-3 tw-py-2.5 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer hover:tw-bg-[#f5f5f5]"
                onClick={function() { self.setState({ search: '', filterStatus: '', filterRole: '', sortBy: 'newest', dateFrom: '', dateTo: '' }, function() { self.fetchUsers(1); }); }}
              >
                <i className="fa fa-times tw-mr-1" />Clear
              </button>
            )}
          </div>
        </div>

        {/* Loading */}
        {this.state.loading && (
          <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
            <div className="tw-text-center">
              <i className="fa fa-circle-o-notch fa-spin tw-text-3xl tw-mb-3" style={{ color: '#D4A843', display: 'block' }} />
              <span className="tw-text-sm tw-text-[#999]">Loading users...</span>
            </div>
          </div>
        )}

        {/* Table */}
        {!this.state.loading && (
          <div className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            <div className="tw-overflow-x-auto">
              <table className="tw-w-full tw-text-sm">
                <thead>
                  <tr style={{ backgroundColor: isDark ? '#111' : '#fafafa', borderBottom: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider">User</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden md:tw-table-cell">Email</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider">Status</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden lg:tw-table-cell">Role</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden lg:tw-table-cell">Strikes</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden xl:tw-table-cell">Payment</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden xl:tw-table-cell">Location</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden md:tw-table-cell">Joined</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map(function(user) {
                    var badge = STATUS_BADGE[user.status] || STATUS_BADGE.active;
                    var roleBg = user.role === 'admin' ? '#D4A843' : '#6B7280';
                    return (
                      <tr
                        key={user._id}
                        className="tw-border-b tw-border-[#f0f0f0] dark:tw-border-[#222] hover:tw-bg-[#f9f9f9] dark:hover:tw-bg-[#151515] tw-transition-colors tw-cursor-pointer"
                        onClick={function() { if (onOpenUserModal) onOpenUserModal(user._id); }}
                      >
                        <td className="tw-px-4 tw-py-3.5">
                          <div className="tw-flex tw-items-center tw-gap-2.5">
                            {user.image ? (
                              <img src={user.image.startsWith('http') ? user.image : constants.DOMAIN + '/' + user.image} alt="" className="tw-w-8 tw-h-8 tw-rounded-full tw-object-cover tw-flex-shrink-0" />
                            ) : (
                              <div className="tw-w-8 tw-h-8 tw-rounded-full tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: '#f0f0f0' }}>
                                <i className="fa fa-user tw-text-xs tw-text-[#ccc]" />
                              </div>
                            )}
                            <div>
                              <span className="tw-text-sm tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white">{user.userName}</span>
                              {user.shopActive === false && (
                                <span className="tw-text-[10px] tw-ml-1.5 tw-px-1.5 tw-py-0.5 tw-rounded tw-font-medium tw-text-white" style={{ backgroundColor: '#EF4444' }}>Closed</span>
                              )}
                            </div>
                          </div>
                        </td>
                        <td className="tw-px-4 tw-py-3.5 tw-text-sm tw-text-[#666] dark:tw-text-[#aaa] tw-hidden md:tw-table-cell">{user.email}</td>
                        <td className="tw-px-4 tw-py-3.5">
                          <span className="tw-text-xs tw-px-2 tw-py-1 tw-rounded-full tw-font-medium tw-text-white" style={{ backgroundColor: badge.bg }}>{badge.label}</span>
                        </td>
                        <td className="tw-px-4 tw-py-3.5 tw-hidden lg:tw-table-cell">
                          <span className="tw-text-xs tw-px-2 tw-py-1 tw-rounded-full tw-font-medium tw-text-white" style={{ backgroundColor: roleBg }}>{user.role || 'user'}</span>
                        </td>
                        <td className="tw-px-4 tw-py-3.5 tw-hidden lg:tw-table-cell">
                          {user.strikeCount > 0 ? (
                            <span className="tw-text-xs tw-font-bold" style={{ color: '#EF4444' }}>
                              <i className="fa fa-exclamation-circle tw-mr-1" />{user.strikeCount}
                            </span>
                          ) : (
                            <span className="tw-text-xs tw-text-[#999]">0</span>
                          )}
                        </td>
                        <td className="tw-px-4 tw-py-3.5 tw-hidden xl:tw-table-cell">
                          {user.hasPayment ? (
                            <span className="tw-text-xs" style={{ color: '#10B981' }}><i className="fa fa-check-circle" /></span>
                          ) : (
                            <span className="tw-text-xs tw-text-[#999]"><i className="fa fa-minus" /></span>
                          )}
                        </td>
                        <td className="tw-px-4 tw-py-3.5 tw-text-xs tw-text-[#999] tw-hidden xl:tw-table-cell">{user.location || '—'}</td>
                        <td className="tw-px-4 tw-py-3.5 tw-text-xs tw-text-[#999] tw-hidden md:tw-table-cell">{user.createdAt ? formatDate(user.createdAt) : '—'}</td>
                      </tr>
                    );
                  })}
                  {users.length === 0 && (
                    <tr><td colSpan="8" className="tw-px-4 tw-py-12 tw-text-center tw-text-[#999]">
                      <i className="fa fa-users tw-text-3xl tw-mb-2" style={{ display: 'block' }} />No users found
                    </td></tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            {pagination.pages > 1 && (
              <div className="tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-3" style={{ borderTop: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
                <span className="tw-text-xs tw-text-[#999]">
                  Showing {((pagination.page - 1) * pagination.limit) + 1}–{Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total}
                </span>
                <div className="tw-flex tw-gap-1">
                  <button
                    className="tw-px-3 tw-py-1.5 tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-40"
                    disabled={pagination.page <= 1}
                    onClick={function() { self.fetchUsers(pagination.page - 1); }}
                  >Prev</button>
                  <button
                    className="tw-px-3 tw-py-1.5 tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-40"
                    disabled={pagination.page >= pagination.pages}
                    onClick={function() { self.fetchUsers(pagination.page + 1); }}
                  >Next</button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default AdminUsers;
